import React from "react";
import { Toolbar, Grid, Button } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";

import RightSideButton from "./RightSideButton";
import LeftSideButton from "./LeftSideButton";

const HeaderBar = ({
  gridAction,
  selectedEqList,
  reportCode,
  saveFilterList,
  rowCount,
  handleMultipleActive,
}) => {
  {
    return (
      <>
        <Toolbar className="gridTableHeaderContainor">
          <Grid container justifyContent="space-between" alignItems="center">
            <LeftSideButton
              gridAction={gridAction}
              reportCode={reportCode}
              saveFilterList={saveFilterList}
              selectedEqList={selectedEqList}
            />

            <RightSideButton
              gridAction={gridAction}
              rowCount={rowCount}
              reportCode={reportCode}
              selectedEqList={selectedEqList}
              handleMultipleActive={handleMultipleActive}
            />
          </Grid>
        </Toolbar>
      </>
    );
  }
};

export default HeaderBar;
